(function () {
  var instances = new WeakMap();

  var updateFraction = function (section, swiper) {
    var fractionEl = section.querySelector('.custom-hero-slider__fraction');

    if (!fractionEl || !swiper) {
      return;
    }

    var total = swiper.slides.length;

    if (swiper.params.loop) {
      total = swiper.slides.filter(function (slide) {
        return !slide.classList.contains('swiper-slide-duplicate');
      }).length;
    }

    var current = swiper.realIndex + 1;
    fractionEl.textContent = current + '/' + total;
  };

  var resetHeadingAnimations = function (section) {
    section.querySelectorAll('.custom-hero-slider__slide').forEach(function (slide) {
      slide.classList.remove('is-heading-animating');

      slide.querySelectorAll('.custom-hero-slider__heading-main, .custom-hero-slider__accent').forEach(function (el) {
        el.style.animation = 'none';
        el.style.opacity = '';
        el.style.transform = '';
      });
    });
  };

  var setHeadingTravel = function (slide) {
    var content = slide.querySelector('.custom-hero-slider__content');

    if (!content) {
      return;
    }

    var travel = Math.round(content.getBoundingClientRect().width * 0.3);

    content.style.setProperty('--custom-hero-slider-heading-travel', travel + 'px');
  };

  var playHeadingAnimations = function (section, swiper) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.querySelectorAll('.custom-hero-slider__heading-main, .custom-hero-slider__accent').forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    resetHeadingAnimations(section);

    var activeSlide =
      section.querySelector('.custom-hero-slider__swiper .swiper-slide-active') ||
      (swiper && swiper.slides[swiper.activeIndex]);

    if (!activeSlide) {
      return;
    }

    setHeadingTravel(activeSlide);

    activeSlide.querySelectorAll('.custom-hero-slider__heading-main, .custom-hero-slider__accent').forEach(function (el) {
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
      el.style.opacity = '';
      el.style.transform = '';
    });

    activeSlide.classList.add('is-heading-animating');
  };

  var scheduleHeadingAnimations = function (section, swiper) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        playHeadingAnimations(section, swiper);
      });
    });
  };

  var initSlider = function (section) {
    var swiperEl = section.querySelector('.custom-hero-slider__swiper');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return;
    }

    var slideCount = parseInt(section.dataset.slideCount, 10) || 0;
    var enableAutoplay = section.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(section.dataset.autoplayDelay, 10) || 6000;
    var enableLoop = slideCount > 1;
    var bulletsEl = section.querySelector('.custom-hero-slider__bullets');
    var fractionEl = section.querySelector('.custom-hero-slider__fraction');

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      speed: 700,
      loop: enableLoop,
      watchOverflow: true,
      autoplay: enableAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: bulletsEl
        ? {
            el: bulletsEl,
            clickable: true,
          }
        : undefined,
      on: {
        init: function () {
          updateFraction(section, this);
          scheduleHeadingAnimations(section, this);
        },
        transitionStart: function () {
          scheduleHeadingAnimations(section, this);
        },
        slideChange: function () {
          updateFraction(section, this);
        },
      },
    });

    if (!fractionEl) {
      instances.set(section, { swiper: swiper });
      return swiper;
    }

    instances.set(section, { swiper: swiper });
    return swiper;
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-hero-slider]').forEach(function (section) {
      initSlider(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-hero-slider]').forEach(function (section) {
      var instance = instances.get(section);

      if (instance && instance.swiper) {
        instance.swiper.destroy(true, true);
      }

      instances.delete(section);
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
